import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";

import { BsFillArrowLeftCircleFill } from "react-icons/bs";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, isBefore, isValid, parse } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Spacer,
  Divider,
  Icon,
  Text,
  Button,
  Grid,
  GridItem,
  Select,
  HStack,
  useMediaQuery,
  Box,
} from "@chakra-ui/react";

import { CustomDatepicker } from "../../../../components/CustomDatepicker";
import { CardAnexo } from "../../../../components/CardAnexo";
import SemRegistros from "../../../../components/SemRegistros";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";

const VisualizarAnexos = ({ categoria, setCategoriaId }) => {
  const { roleKeycloack } = useAuthProvider();
  const { id } = useParams();
  const history = useHistory();

  const [files, setFiles] = useState(categoria[2]);
  const [ordenacao, setOrdenacao] = useState("mais recente");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [isLessThan600] = useMediaQuery("(max-width: 600px)");
  const hideButton =
    (categoria[1] !== "Outros Anexos" &&
      roleKeycloack &&
      (roleKeycloack.includes(criancaFunc.visualizarTudoTutelar) ||
        roleKeycloack.includes(criancaFunc.visualizarTudoDefensoria) ||
        roleKeycloack.includes(servicoAcolhimentoFunc.visualizarPartePPCAAM) ||
        roleKeycloack.includes(
          servicoAcolhimentoFunc.visualizarParteConsulente
        ))) ||
    roleKeycloack.includes(servicoAcolhimentoFunc.visualizarPartePPCAAM);
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const checkPath = () => {
    let pathToGo = "";
    if (
      categoria[1] === "Outros Anexos" ||
      categoria[1] === "Fotos do Serviço de Acolhimento"
    ) {
      pathToGo = `/servico-acolhimento/cadastrar-anexos/${id}/categoria/${categoria[0]}`;
    } else if (
      categoria[1] === "Projeto Político Pedagógico" ||
      categoria[1] === "Plano de Trabalho" ||
      categoria[1] === "Relatório Anual" ||
      categoria[1] === "Regimento Interno"
    ) {
      pathToGo = `/servico-acolhimento/visualizar-planejamento/${id}`;
    } else if (categoria[1] === "Estatuto da Entidade") {
      pathToGo = `/servico-acolhimento/visualizar-gestao/${id}`;
    } else if (
      categoria[1] === "Registro no CMDCA" ||
      categoria[1] === "Inscrição no CMDCA" ||
      categoria[1] === "Inscrição no CMAS"
    ) {
      pathToGo = `/servico-acolhimento/visualizar-regularidade/${id}`;
    } else if (categoria[1] === "Termo do Voluntariado") {
      pathToGo = `/servico-acolhimento/visualizar-voluntariado/${id}`;
    } else if (categoria[1] === "Oficio de Pessoa em Cumprimento de Pena") {
      pathToGo = `/servico-acolhimento/visualizar-pessoa-em-cumprimento-de-pena/${id}`;
    }
    return pathToGo;
  };

  useEffect(() => {
    let tempFiles = [...categoria[2]];

    if (ordenacao) {
      if (ordenacao === "mais recente") {
        tempFiles = tempFiles.sort((a, b) => {
          return new Date(b.dataAnexo) - new Date(a.dataAnexo);
        });
      } else if (ordenacao === "mais antigo") {
        tempFiles = tempFiles.sort((a, b) => {
          return new Date(a.dataAnexo) - new Date(b.dataAnexo);
        });
      } else {
        tempFiles = [...categoria[2]];
      }
    } else {
      tempFiles = [...categoria[2]];
    }
    if (dataInicial && dataFinal) {
      tempFiles = tempFiles.filter((file) => {
        if (
          new Date(file.dataAnexo) >=
            parse(dataInicial, "dd/MM/yyyy", new Date()) &&
          new Date(file.dataAnexo) <=
            parse(dataFinal, "dd/MM/yyyy", new Date()).setHours(23, 59, 59)
        ) {
          return file;
        }
        return false;
      });
    } else if (isValid(parse(dataInicial, "dd/MM/yyyy", new Date()))) {
      tempFiles = tempFiles.filter(
        (file) =>
          !isBefore(
            new Date(file.dataAnexo),
            parse(dataInicial, "dd/MM/yyyy", new Date())
          )
      );
    } else if (isValid(parse(dataFinal, "dd/MM/yyyy", new Date()))) {
      tempFiles = tempFiles.filter(
        (file) =>
          !isAfter(
            new Date(file.dataAnexo),
            parse(dataFinal, "dd/MM/yyyy", new Date()).setHours(23, 59, 59)
          )
      );
    }
    setFiles(tempFiles);
  }, [ordenacao, dataInicial, dataFinal, categoria]);

  return (
    <Flex
      bgColor="#FFF"
      p="20px"
      mt="15px"
      borderRadius="16px"
      flexDir="column"
    >
      <Flex alignItems="center">
        <Icon
          aria-label="Voltar"
          color="#169499"
          as={BsFillArrowLeftCircleFill}
          boxSize="30px"
          _hover={{ cursor: "pointer" }}
          onClick={() => {
            setCategoriaId(-1);
          }}
        />
        <Text
          color="#95BCBF"
          fontWeight="700"
          fontSize="16px"
          lineHeight="21.6px"
          ml="10px"
        >
          ANEXOS - {categoria[1].toString().toUpperCase()}
        </Text>
        <Spacer />
        <Button
          w="max-content"
          color="#FFF"
          backgroundColor="#169499"
          fontWeight={700}
          fontSize="15px"
          lineHeight="21.6px"
          px="40px"
          py="10px"
          _hover={{ bg: "#169499" }}
          onClick={() => {
            history.push(checkPath());
          }}
          display={hideButton ? "none" : "inline-flex"}
        >
          Adicionar
        </Button>
      </Flex>
      <Divider orientation="horizontal" mt="10px" />

      <Grid
        mt="30px"
        templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(3, 1fr)" }}
        gap="25px"
      >
        <Select
          name="ordenar"
          value={ordenacao}
          onChange={(e) => setOrdenacao(e.target.value)}
          placeholder={"Ordenar por..."}
          backgroundColor="white"
          h="42px"
        >
          <option value="mais recente">Mais Recente</option>
          <option value="mais antigo">Mais Antigo</option>
        </Select>
        <HStack spacing="10px">
          <CustomDatepicker
            placeholder="DD/MM/AAAA"
            setValue={(date) => setDataInicial(date)}
            value={dataInicial}
          />
          <Text>até</Text>
          <CustomDatepicker
            placeholder="DD/MM/AAAA"
            setValue={(date) => setDataFinal(date)}
            value={dataFinal}
          />
        </HStack>
      </Grid>
      {files.length > 0 ? (
        <Box
          maxH="500px"
          overflowY={files && files.length > 8 ? "auto" : "initial"}
        >
          <Grid
            templateColumns={
              !isLessThan600 && files.length > 3
                ? "repeat(auto-fit, minmax(230px, 1fr))"
                : !isLessThan600 && files.length <= 3
                ? "repeat(auto-fill, minmax(230px, 1fr))"
                : ""
            }
            mt={6}
            gap={6}
            justifyContent="center"
            alignItems="center"
          >
            {files.map((file) => {
              const customDateDocument = file.dataAnexo
                ? new Date(file.dataAnexo).toLocaleDateString("pt-BR")
                : "";

              const customDateInitial = file.dataUploadAnexo
                ? new Date(file.dataUploadAnexo).toLocaleDateString("pt-BR")
                : "";

              return (
                <GridItem colSpan={1}>
                  <CardAnexo
                    title={`${
                      file.categoriaAnexo.nomeCategoria
                        ? file.categoriaAnexo.nomeCategoria
                        : ""
                    }`}
                    responsavel={`${
                      file.usuarioResponsavel ? file.usuarioResponsavel : ""
                    }`}
                    dataDocumento={`${customDateDocument}`}
                    dataInitial={`${customDateInitial}`}
                    key={file.id}
                    idDelete={file.id}
                    tipoCard={"servico"}
                    observacoes={
                      [6, 12].includes(file?.categoriaAnexo?.id)
                        ? file.descricaoAnexo
                        : null
                    }
                  />
                </GridItem>
              );
            })}
          </Grid>
        </Box>
      ) : (
        <Box mt={5}>
          <SemRegistros buttonVisible={true} half />
        </Box>
      )}
    </Flex>
  );
};

export default VisualizarAnexos;
